import { WithRouterGuard } from '@/common/components/RouterGuard/RouterGuard';
import { MARKET, PLAN } from '@/common/constants/markets';
import { SavingsPage } from '@/web/containers/SavingsPage/SavingsPage';

export default function SavingsRootPage() {
  return WithRouterGuard(<SavingsPage />, {
    market: [MARKET.PT],
    plan: [PLAN.WALLET],
  });
}
